// One rollup contract for the server's portfolio and the record's selected city.
export function computeRagVerdict(projectedHc, capacityBasis, attendanceUnknown, insufficientHistory) {
  if (insufficientHistory) return "insufficient_history";
  if (attendanceUnknown) return "attendance_unknown";
  if (capacityBasis == null || capacityBasis <= 0) return "attendance_unknown";
  if (projectedHc >= capacityBasis) return "over";
  if (projectedHc >= 0.9 * capacityBasis) return "tight";
  return "covered";
}

export function summarizeMarketPressure(markets, quarters) {
  const actionNow = markets.filter((m) => m.quarters.some((q) => q.verdict === "over")).length;
  const watchNext12Mo = markets.filter((m) =>
    m.quarters.slice(0, Math.min(4, quarters.length)).some((q) => q.verdict === "tight" || q.verdict === "over")
  ).length;
  const covered = markets.filter((m) =>
    m.quarters.every((q) => ["covered", "attendance_unknown", "insufficient_history"].includes(q.verdict))
      && m.quarters.some((q) => q.verdict === "covered")
  ).length;
  let nextWall = null;
  for (let qi = 0; qi < quarters.length; qi++) {
    const breached = markets.filter((m) => m.quarters[qi]?.verdict === "over");
    if (breached.length) {
      nextWall = { quarter: quarters[qi].label, markets: breached.map((m) => m.name), marketCount: breached.length };
      break;
    }
  }
  const flagged = (basis) => markets.filter((m) =>
    (m.offices ?? []).some((o) => (o.cells ?? []).some((c) => {
      const verdict = basis === "usable"
        ? computeRagVerdict(c.projectedHc, c.usableAtQ, c.attendanceUnknown, c.insufficientHistory)
        : computeRagVerdict(c.projectedHc, c.seatsAtQ > 0 ? c.seatsAtQ : null, false, c.insufficientHistory);
      return verdict === "over" || verdict === "tight";
    }))
  ).length;
  return { actionNow, watchNext12Mo, covered, nextWall,
    falseAlarmStats: { usableFlagged: flagged("usable"), seatsFlagged: flagged("seats") } };
}

export function scopeMarketPressure(data, marketId) {
  if (!data || !marketId) return data;
  const markets = (data.markets ?? []).filter((m) => m.id === marketId);
  return { ...data, markets, kpis: summarizeMarketPressure(markets, data.quarters ?? []) };
}
